import { ConcreteEncodable } from "./ConcreteEncodable";

import { XferEventImplEncoder } from "../../encoder/XferEventImplEncoder";

import * as CubiqTS from "../../index";
import { XferEvent } from "../XferEvent";

export class XferEventImpl extends ConcreteEncodable implements XferEvent {
  public static enType: string = "com.bcdfx.model.event.lifecycle.XferEventImpl";

  /*FID=1*/
  public orderData: Array<CubiqTS.OrderData> | null = null;
  /*FID=2*/
  public eventType: CubiqTS.XferType;
  /*FID=3*/
  public targetGroupBranchCd: string;
  /*FID=4*/
  public targetGroupId: CubiqTS.Long | null = null;
  /*FID=5*/
  public actioningUserId: CubiqTS.Long | null = null;
  /*FID=6*/
  public comment: string;
  /*FID=7*/
  public sourceTradingGroups: Array<CubiqTS.Long> | null = null;
  /*FID=8*/
  public orderIds: Array<CubiqTS.Long> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = XferEventImplEncoder.Instance;
    this.setEncodableType(XferEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "XferEventImpl[" +
      "orderData=" +
      this.orderData +
      "eventType=" +
      this.eventType +
      "targetGroupBranchCd=" +
      this.targetGroupBranchCd +
      "targetGroupId=" +
      this.targetGroupId +
      "actioningUserId=" +
      this.actioningUserId +
      "comment=" +
      this.comment +
      "sourceTradingGroups=" +
      this.sourceTradingGroups +
      "orderIds=" +
      this.orderIds +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
